module.exports = __webpack_public_path__ + "img/depmap_svg_V148.2ec26fde.svg";